export const SOURCE_VIDAPP = "VidApp";

export const SOURCE_TYPE_COLLECTION = "Collection";
